export default "__VITE_ASSET__BVlw_Lb7__"